// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Calibre/WebFonts/CalibreWeb-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Calibre/WebFonts/CalibreWeb-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Calibre/WebFonts/CalibreWeb-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/RealtimeRounded/JuriZaechRealtimeRounded.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Calibre';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: normal;
}
@font-face {
  font-family: 'Calibre';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: bold;
}
@font-face {
  font-family: 'Calibre';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: medium;
}

@font-face {
  font-family: 'RealtimeRounded';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}

body {
  font-family: "Calibre";
  background-color: #ededed;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.calibre {
  font-family: "Calibre";
}
.realtime-rounded {
  font-family: "RealtimeRounded";
}

.border-panther{
  border-color: rgb(39,50,36) !important;
}
.border-change{
  border-color: rgb(0, 24, 92) !important;
}

.text-change{
  color: rgb(0, 24, 92);
}
.text-midnight{
  color: rgb(26,34,42);
}
.text-panther{
  color: rgb(39,50,36);
}
.text-stone{
  color: rgb(165,165,165);
}
.text-snow{
  color: rgb(249,249,249);
}
.text-paper{
  color: rgb(237,237,237);
}
.text-sand{
  color: rgb(237,230,220);
}
.text-mustard{
  color: rgb(214,150,3);
}
.text-portfolio{
  color: rgb(204,255,153);
}
.text-warning{
  color: rgb(255,102,152);
}
.text-success {
  color: rgb(18, 183, 52);
}


.bg-change{
  background-color: rgb(0, 24, 92) !important;
}
.bg-midnight{
  background-color: rgb(26,34,42) !important;
}
.bg-panther{
  background-color: rgb(39,50,36) !important;
}
.bg-stone{
  background-color: rgb(165,165,165) !important;
}
.bg-snow{
  background-color: rgb(249,249,249) !important;
}
.bg-paper{
  background-color: rgb(237,237,237) !important;
}
.bg-sand{
  background-color: rgb(237,230,220) !important;
}
.bg-mustard{
  background-color: rgb(214,150,3) !important;
}
.bg-portfolio{
  background-color: rgb(204,255,153) !important;
}
.bg-warning{
  background-color: rgb(255,102,152) !important;
}
.bg-success {
  background-color: rgb(18, 183, 52) !important;
}
/* .form-control:invalid {
  border-color: red !important;
  border-width: 2px;
} */

/* ======================== */
/*            Svg           */
/* ======================== */

.svg-white{
  filter: brightness(0) invert(1);
}

.svg-midnight{
  filter: brightness(0) saturate(100%) invert(10%) sepia(69%) saturate(3490%) hue-rotate(219deg) brightness(81%) contrast(109%);
}

.svg-panther{
  filter: brightness(0) saturate(100%) invert(16%) sepia(41%) saturate(294%) hue-rotate(61deg) brightness(94%) contrast(93%);
}

.svg-warning{
  filter: brightness(0) saturate(100%) invert(57%) sepia(74%) saturate(1656%) hue-rotate(303deg) brightness(99%) contrast(105%);
}

.svg-mustard{
  filter: invert(53%) sepia(97%) saturate(1082%) hue-rotate(11deg) brightness(96%) contrast(98%);
}
.svg-portfolio{
  filter: brightness(0) saturate(100%) invert(91%) sepia(21%) saturate(732%) hue-rotate(36deg) brightness(102%) contrast(101%);
}

.svg-change{
  filter: brightness(0) saturate(100%) invert(10%) sepia(49%) saturate(5912%) hue-rotate(215deg) brightness(79%) contrast(113%);
}

.svg-success {
  filter: brightness(0) saturate(100%) invert(40%) sepia(100%) saturate(6318%) hue-rotate(109deg) brightness(113%) contrast(100%);
}


/* ======================== */
/*           Table          */
/* ======================== */

/* center table td eg. edit */
.table-td-center{
  text-align: center;
}


/* ======================== */
/*            Form          */
/* ======================== */
.checkbox-border{
  padding: 15px;
  border-radius: 4px;  
}

/* ======================== */
/*    Confirmation Modal    */
/* ======================== */
.confirmation-modal-body{
  text-align: center; 
  font-size: 20px;
}

.confirmation-modal-footer{
  justify-content: center;
  
}

.confirmation-modal-button{
  width: 85px;
}

.dynModalInBackground{
  opacity: 0.0;
}


/* ======================== */
/*         Layout           */
/* ======================== */

.layout-content{
  margin-top: 75px;
}

@media screen and (min-width: 48rem) {
  .layout-content{
    width: calc(100vw - 250px);
  }
}

@media screen and (max-width: 48rem) {
  .layout-content{
    width: calc(100vw);
  }
}

.layout-sidebar{
  width: 250px;
  height: calc(100vh - 78px);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2DAA8E;EAC9E,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,2DAA2E;EAC3E,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,2DAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+DAAsF;AACxF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;;AAGA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;;;GAGG;;AAEH,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;;AAE7B;EACE,+BAA+B;AACjC;;AAEA;EACE,6HAA6H;AAC/H;;AAEA;EACE,0HAA0H;AAC5H;;AAEA;EACE,6HAA6H;AAC/H;;AAEA;EACE,8FAA8F;AAChG;AACA;EACE,4HAA4H;AAC9H;;AAEA;EACE,6HAA6H;AAC/H;;AAEA;EACE,+HAA+H;AACjI;;;AAGA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;;AAE7B,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;;AAGA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;;AAE7B;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B","sourcesContent":["@font-face {\n  font-family: 'Calibre';\n  src: url(assets/fonts/Calibre/WebFonts/CalibreWeb-Regular.woff) format('woff');\n  font-weight: normal;\n}\n@font-face {\n  font-family: 'Calibre';\n  src: url(assets/fonts/Calibre/WebFonts/CalibreWeb-Bold.woff) format('woff');\n  font-weight: bold;\n}\n@font-face {\n  font-family: 'Calibre';\n  src: url(assets/fonts/Calibre/WebFonts/CalibreWeb-Medium.woff) format('woff');\n  font-weight: medium;\n}\n\n@font-face {\n  font-family: 'RealtimeRounded';\n  src: url(assets/fonts/RealtimeRounded/JuriZaechRealtimeRounded.otf) format('opentype');\n}\n\nbody {\n  font-family: \"Calibre\";\n  background-color: #ededed;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.calibre {\n  font-family: \"Calibre\";\n}\n.realtime-rounded {\n  font-family: \"RealtimeRounded\";\n}\n\n.border-panther{\n  border-color: rgb(39,50,36) !important;\n}\n.border-change{\n  border-color: rgb(0, 24, 92) !important;\n}\n\n.text-change{\n  color: rgb(0, 24, 92);\n}\n.text-midnight{\n  color: rgb(26,34,42);\n}\n.text-panther{\n  color: rgb(39,50,36);\n}\n.text-stone{\n  color: rgb(165,165,165);\n}\n.text-snow{\n  color: rgb(249,249,249);\n}\n.text-paper{\n  color: rgb(237,237,237);\n}\n.text-sand{\n  color: rgb(237,230,220);\n}\n.text-mustard{\n  color: rgb(214,150,3);\n}\n.text-portfolio{\n  color: rgb(204,255,153);\n}\n.text-warning{\n  color: rgb(255,102,152);\n}\n.text-success {\n  color: rgb(18, 183, 52);\n}\n\n\n.bg-change{\n  background-color: rgb(0, 24, 92) !important;\n}\n.bg-midnight{\n  background-color: rgb(26,34,42) !important;\n}\n.bg-panther{\n  background-color: rgb(39,50,36) !important;\n}\n.bg-stone{\n  background-color: rgb(165,165,165) !important;\n}\n.bg-snow{\n  background-color: rgb(249,249,249) !important;\n}\n.bg-paper{\n  background-color: rgb(237,237,237) !important;\n}\n.bg-sand{\n  background-color: rgb(237,230,220) !important;\n}\n.bg-mustard{\n  background-color: rgb(214,150,3) !important;\n}\n.bg-portfolio{\n  background-color: rgb(204,255,153) !important;\n}\n.bg-warning{\n  background-color: rgb(255,102,152) !important;\n}\n.bg-success {\n  background-color: rgb(18, 183, 52) !important;\n}\n/* .form-control:invalid {\n  border-color: red !important;\n  border-width: 2px;\n} */\n\n/* ======================== */\n/*            Svg           */\n/* ======================== */\n\n.svg-white{\n  filter: brightness(0) invert(1);\n}\n\n.svg-midnight{\n  filter: brightness(0) saturate(100%) invert(10%) sepia(69%) saturate(3490%) hue-rotate(219deg) brightness(81%) contrast(109%);\n}\n\n.svg-panther{\n  filter: brightness(0) saturate(100%) invert(16%) sepia(41%) saturate(294%) hue-rotate(61deg) brightness(94%) contrast(93%);\n}\n\n.svg-warning{\n  filter: brightness(0) saturate(100%) invert(57%) sepia(74%) saturate(1656%) hue-rotate(303deg) brightness(99%) contrast(105%);\n}\n\n.svg-mustard{\n  filter: invert(53%) sepia(97%) saturate(1082%) hue-rotate(11deg) brightness(96%) contrast(98%);\n}\n.svg-portfolio{\n  filter: brightness(0) saturate(100%) invert(91%) sepia(21%) saturate(732%) hue-rotate(36deg) brightness(102%) contrast(101%);\n}\n\n.svg-change{\n  filter: brightness(0) saturate(100%) invert(10%) sepia(49%) saturate(5912%) hue-rotate(215deg) brightness(79%) contrast(113%);\n}\n\n.svg-success {\n  filter: brightness(0) saturate(100%) invert(40%) sepia(100%) saturate(6318%) hue-rotate(109deg) brightness(113%) contrast(100%);\n}\n\n\n/* ======================== */\n/*           Table          */\n/* ======================== */\n\n/* center table td eg. edit */\n.table-td-center{\n  text-align: center;\n}\n\n\n/* ======================== */\n/*            Form          */\n/* ======================== */\n.checkbox-border{\n  padding: 15px;\n  border-radius: 4px;  \n}\n\n/* ======================== */\n/*    Confirmation Modal    */\n/* ======================== */\n.confirmation-modal-body{\n  text-align: center; \n  font-size: 20px;\n}\n\n.confirmation-modal-footer{\n  justify-content: center;\n  \n}\n\n.confirmation-modal-button{\n  width: 85px;\n}\n\n.dynModalInBackground{\n  opacity: 0.0;\n}\n\n\n/* ======================== */\n/*         Layout           */\n/* ======================== */\n\n.layout-content{\n  margin-top: 75px;\n}\n\n@media screen and (min-width: 48rem) {\n  .layout-content{\n    width: calc(100vw - 250px);\n  }\n}\n\n@media screen and (max-width: 48rem) {\n  .layout-content{\n    width: calc(100vw);\n  }\n}\n\n.layout-sidebar{\n  width: 250px;\n  height: calc(100vh - 78px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
